<div id="app"><Snackbar ref="snackbar"></Snackbar><main><router-view></router-view></main><Footer v-if="showFooter"></Footer></div>